import { useQuery } from '@tanstack/react-query'
import { fetchTakeABreakDetails } from '@core/Areas/Account/Pages/TakeABreak/helpers/api'
import { queryKeys } from '@core/Data/ReactQuery/constants'
import { useLogon } from '@core/Utils/hooks'

export function useTakeABreak() {
  const { accountNumber } = useLogon()

  const { data, isError, error, isSuccess, isLoading } = useQuery({
    queryKey: [queryKeys.takeABreak, accountNumber],
    queryFn: fetchTakeABreakDetails,
    gcTime: accountNumber ? 300000 : 0,
    enabled: !!accountNumber,
  })

  return { data, isLoading, isError, error, isSuccess }
}
